import { ColumnConfigKey } from "../types/page-config/column-customizer/ColumnConfigKey";
import { bwicColumnsLabels } from "./bwicColumnsLabels";

export const loanMonitorColumnLabels: { [key in ColumnConfigKey]: string } = {
    ...bwicColumnsLabels,
    [ColumnConfigKey.IssuerName]: 'Issuer',
    [ColumnConfigKey.LastUpdated]: 'Last Updated',
    [ColumnConfigKey.Status]: 'Status',
    [ColumnConfigKey.Review]: 'Review',
    [ColumnConfigKey.AnalystUserId]: 'Analyst',
    [ColumnConfigKey.LenderCallDate]: 'Lender Call',
    [ColumnConfigKey.ArrangerReferenceName]: 'Arranger',
    [ColumnConfigKey.Contacts]: 'Syndicate',
    [ColumnConfigKey.DueDate]: 'Due',
    [ColumnConfigKey.InitialGuidance]: 'Initial Guidance',
    [ColumnConfigKey.Guidance]: 'Guidance',
    [ColumnConfigKey.GuidanceChange]: 'Guidance Chg',
    [ColumnConfigKey.Floor]: 'Floor, %',
    [ColumnConfigKey.Price]: 'Price',
    [ColumnConfigKey.Size]: 'Size, MM',
    [ColumnConfigKey.AddOn]: 'Add-on, MM',
    [ColumnConfigKey.TrancheRating]: 'Tranche Rtg, M/S/F',
    [ColumnConfigKey.CFRating]: 'CF Rtg, M/S/F',
    [ColumnConfigKey.TermYears]: 'Term, yrs',
    [ColumnConfigKey.Maturity]: 'Maturity',
    [ColumnConfigKey.Facility]: 'Facility',
    [ColumnConfigKey.CovLite]: 'Cov-Lite',
    [ColumnConfigKey.Industry]: 'Industry',
    [ColumnConfigKey.IssuerDescription]: 'Issuer Description',
    [ColumnConfigKey.UseOfProceeds]: 'Use of Proceeds',
    [ColumnConfigKey.PricingDate]: 'Pricing',
    [ColumnConfigKey.Order]: 'Order, MM',
    [ColumnConfigKey.Target]: 'Target, MM',
    [ColumnConfigKey.Allocation]: 'Allocation, MM',
    [ColumnConfigKey.AllocationPct]: 'Allocation, %',
    [ColumnConfigKey.CallProtection]: 'Call Protection',
    [ColumnConfigKey.CoArrangers]: 'Co-Arranger',
    [ColumnConfigKey.CurrencyCode]: 'Ccy',
    [ColumnConfigKey.RefIndex]: 'Ref Index',
    [ColumnConfigKey.Margin]: 'Margin',
    [ColumnConfigKey.Dataroom]: 'Dataroom',
    [ColumnConfigKey.Actions]: 'Actions',
};
